export default __webpack_public_path__ + "assets/images/4adc1a7ddbb04b3195da348603993907.png";